import React, { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating';
import { db, auth } from '../../../firebase';
import StarIcon from '@mui/icons-material/Star';
import Box from '@mui/material/Box';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { toast } from 'react-toastify';
import swal from "@sweetalert/with-react";
import { Modal, Button } from 'react-bootstrap';
import Comments from './Comments';

const labels = {
  0.5: '0.5 Useless',
  1: '1 Useless+',
  1.5: '1.5 Poor',
  2: '2 Poor+',
  2.5: '2.5 Ok',
  3: '3 Ok+',
  3.5: '3.5 Good',
  4: '4 Good+',
  4.5: '4.5 Excellent',
  5: '5 Excellent+',
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
}

function Reviews({ branchId }) {
  const [show, setShow] = useState(false);
  const [posts, setPosts] = useState([])
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [value, setValue] = React.useState(0);
  const [hover, setHover] = React.useState(-1);
  const [comment, setComment] = useState('')
  const [countReviews, setCountReviews] = useState(0)

  useEffect(() => {
      db.collection('branches').doc(branchId).collection("reviews")
     .onSnapshot(snapshot => (
      setCountReviews(snapshot.docs.length)
     ))
  }, []);
  function abbrNum(number, decPlaces) {
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10,decPlaces);
  
    // Enumerate number abbreviations
    var abbrev = [ "K", "M", "B", "T" ];
  
    // Go through the array backwards, so we do the largest first
    for (var i=abbrev.length-1; i>=0; i--) {
  
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10,(i+1)*3);
  
        // If the number is bigger or equal do the abbreviation
        if(size <= number) {
             // Here, we multiply by decPlaces, round, and then divide by decPlaces.
             // This gives us nice rounding to a particular decimal place.
             number = Math.round(number*decPlaces/size)/decPlaces;
  
             // Add the letter for the abbreviation
             number += abbrev[i];
  
             // We are done... stop
             break;
        }
    }
  
    return number;
  }

  useEffect(() => {
    db.collection('branches').doc(branchId).collection("reviews").onSnapshot(snapshot => {
          setPosts(snapshot.docs.map(doc => ({
              id: doc.id,
              post: doc.data(),
          })));
      })
  }, []);

 const totalRatings = (posts.reduce((a,v) =>  a = a + v.post.rating , 0 ))
 const numberOfRatings = posts.length
 const rating = totalRatings / numberOfRatings
 var a = Math.round(rating * 10) / 10


 const submitReview = () => {
     if(value === 0){
         toast.error("Kindly rate the stars!")
     }else if(value === null){
      toast.error("Kindly rate the stars!")
  }else{
      db.collection("branches").doc(branchId).collection("reviews").add({
          ratedByUid:auth?.currentUser?.uid,
          rating:value,
          ratingComment:comment,
          ratingTime: Date.now(),
      }).
      then((e)=> 
      console.log(e),
      handleClose(),
      setValue(0),
      setComment(""),
      swal("Thanks for your feedback ✔️!")
      )
     }
 }
  return (
    <div>

                  <div className="bg-white rounded shadow-sm p-4 mb-4 clearfix graph-star-rating">
                    <h5 className="mb-0 mb-4">Ratings and Reviews</h5>
                    <div className="graph-star-rating-header">
                      <div className="star-rating" style={{alignItems:'center',display:'flex'}}>
                        <div>
                        <Rating name="half-rating-read" value={a} precision={0.5} readOnly />
                        </div>
                        <div style={{marginLeft:5}}>
                      <b style={{color: "#e74c3c"}}><p className=" mt-2 ml-2">Rated {numberOfRatings === 0 ?(<>0</>):(<>{a}</>)} out of 5</p></b>
                        </div>
                      </div>
                      <b style={{color:"#e74c3c"}}>{abbrNum(countReviews,0)} Review(s)</b>
                    </div>
                    <div  className="graph-star-rating-footer text-center mt-3 mb-3">
                      {auth?.currentUser?.uid ?(
                      <button onClick={handleShow} type="button" className="btn btn-outline-primary btn-sm">Rate and Review</button>
                      ):(
                        <button onClick={() => alert("Kindly Sign In first\nThanks!")} type="button" className="btn btn-outline-primary btn-sm">Rate and Review</button>
                      )}
                    </div>
                  </div>

           <Comments branchId={branchId}/>
                  <Modal show={show} onHide={handleClose}>

<Modal.Body>
<div className="bg-white rounded shadow-sm p-0 mb-2 rating-review-select-page">
<div className="mb-4">
    <center style={{fontWeight:'bold'}}>Kindly Rate Us!</center>
    <center>
    <Box
sx={{
width: 200,
display: 'flex',
alignItems: 'center',
}}
>
<Rating
name="hover-feedback"
value={value}
precision={0.5}
getLabelText={getLabelText}
onChange={(event, newValue) => {
  setValue(newValue);
}}
onChangeActive={(event, newHover) => {
  setHover(newHover);
}}
emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
/>
{value !== null && (
<Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
)}
</Box>
    </center> 
</div>
<form>
  <div className="form-group">
    <textarea className="form-control" value={comment} onChange={e => setComment(e.target.value)}  placeholder={"Your Comment..."} />
  </div>
  <div className="form-group">
    <button onClick={submitReview} className="btn btn-primary btn-sm" type="button"> Submit Comment </button>
  </div>
</form>
</div>
</Modal.Body>
<Modal.Footer>
  <Button variant="primary" onClick={handleClose}>
    Close
  </Button>
</Modal.Footer>
</Modal>
    </div>
  )
}

export default Reviews